import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OpentokService } from "../_services/opentok.service";
import { Caption } from "../_models/models";
import Enumerable from "linq";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { OrganizationService, StreamBoxService } from "../_services/generatedServices";
import { ConferenceRoomViewModel } from "../_models/generatedModels";
import { ActivatedRoute } from "@angular/router";
import { SettingsProvider } from "../_services/settingsProvider.service";

@Component({
  selector: 'bxl-captions-display',
  templateUrl: 'captions-display.component.html',
})
export class CaptionsDisplayComponent implements OnInit {
  initialized = false;
  private session: OT.Session;
  captions: Caption[] = [];
  strCaptions: string [] = [''];
  strCaptionsDisplay: string[] = [];
  private lastFinalCaption: string = '';
  private allFinalizedText: string = ''; // Track all text that's been finalized
  private currentInterimCaption: string = ''; // Track the current interim being displayed
  private interimUpdateTimer: any;
  private lastInterimLength: number = 0;

  private lastInterimCaption: string = '';
  private captionDebounceTimer: any;


  currentIndex = 0;
  @ViewChild('card') private card: ElementRef;
  rooms: ConferenceRoomViewModel[];
  private conferenceSlug: string;
  public selectedRoom: number;
  fontSize: number = 20;
  private subscription: OT.Subscriber;


  constructor(private route: ActivatedRoute, public settingsProvider: SettingsProvider, private streamboxService: StreamBoxService, private openTokService: OpentokService, private organizationService: OrganizationService, private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((parentParam) => {
      this.conferenceSlug = parentParam.get('conferenceSlug');
      this.organizationService.getRoomsForConference(this.conferenceSlug).subscribe((result) => {
        this.rooms = Enumerable.from(result).where(x => x.channel != null).toArray();
        this.initialized = true;
      });
    });
  }

  public scrollToBottom(check: boolean): void {
    if (!this.card || !this.card.nativeElement) {
      return;
    }
    // Reduce delay since we want it to feel more responsive
    of(null)
      .pipe(delay(100))
      .subscribe((result) => {
        this.card.nativeElement?.scroll({
          top: this.card.nativeElement?.scrollHeight,
          left: 0,
          behavior: 'smooth',
        });
      });
  }

  public roomUpdated() {
    if (this.session) {
      this.session.off('streamCreated');
      this.session.unsubscribe(this.subscription);
      this.session.disconnect();
      this.session = null;
    }
    // Reset caption state when switching rooms
    this.strCaptions = [];
    this.strCaptionsDisplay = [];
    this.currentIndex = 0;
    this.lastFinalCaption = '';
    this.allFinalizedText = '';
    this.currentInterimCaption = '';
    this.lastInterimLength = 0;

    if (this.interimUpdateTimer) {
      clearTimeout(this.interimUpdateTimer);
      this.interimUpdateTimer = null;
    }

    console.log('room updated to: ' + this.selectedRoom);

    this.streamboxService.getStreamboxForRoomId(this.selectedRoom).subscribe((result) => {
      console.log("LOading captions for channel: " + result.azureChannel);
      this.InitOpenTok(result.id);
    });
  }

  private InitOpenTok(streamboxId: number) {
    this.openTokService
      .initsessionForStreamBoxCaptions(streamboxId)
      .then((session: OT.Session) => {
        this.session = session;
        this.session.on('streamCreated', (event) => {
          console.log('here');
          console.log(event.stream.name);
          console.log(event.stream.connection.data);

          this.subscription = this.session.subscribe(event.stream, 'videoCanvas', {
            insertMode: 'append',
            subscribeToAudio: false,
            subscribeToVideo: false,
            preferredResolution: {
              width: 1280,
              height: 720
            },
            style: {nameDisplayMode: 'off'},
          });
          this.subscription.element.hidden = true;

          this.subscription.subscribeToCaptions(true);
          this.subscription.on('captionReceived', (event) => {
            console.log(`Caption received for stream ${event.streamId}`);
            console.log(`Caption text: ${event.caption}`);
            console.log(`Final text: ${event.isFinal}`);

            const captionText = event.caption?.trim() || '';

            // Skip empty captions
            if (!captionText) {
              return;
            }

            // Handle final captions - just finalize what we've accumulated
            if (event.isFinal) {
              // Clear any pending interim update timer first
              if (this.interimUpdateTimer) {
                clearTimeout(this.interimUpdateTimer);
                this.interimUpdateTimer = null;
              }

              // When a caption is finalized, save what we've been displaying
              if (this.currentInterimCaption) {
                this.allFinalizedText += (this.allFinalizedText ? '<br><br>' : '') + this.currentInterimCaption;

                // Store the last finalized caption separately for overlap detection
                this.lastFinalCaption = this.currentInterimCaption;
              }

              // Clear interim state for the next batch
              this.currentInterimCaption = '';
              this.lastInterimLength = 0;

              // Update display immediately to show just the finalized text
              this.strCaptionsDisplay = [this.allFinalizedText];
              this.scrollToBottom(true);
              this.ref.detectChanges();

              return;
            }

            // For interim captions: only accept if it's longer AND doesn't duplicate recent content
            if (captionText.length <= this.currentInterimCaption.length) {
              // Ignore shorter or equal length - it's a correction
              return;
            }

            // Check how much has actually changed - if it's just minor corrections, skip the update
            const lengthIncrease = captionText.length - this.currentInterimCaption.length;

            // If the increase is very small (less than 10 characters), it's likely just punctuation/correction
            // Only update if we've added meaningful content OR if this is the first caption
            if (this.currentInterimCaption.length > 0 && lengthIncrease < 10) {
              // Check if new words were actually added (not just punctuation changes)
              const currentWordCount = this.currentInterimCaption.split(/\s+/).filter(w => w.length > 0).length;
              const newWordCount = captionText.split(/\s+/).filter(w => w.length > 0).length;

              if (newWordCount <= currentWordCount) {
                // No new words, just corrections - skip it to reduce flicker
                return;
              }
            }

            // Check if this new caption significantly overlaps with the LAST finalized caption
            // (This happens when a new batch repeats content from the previous batch)
            if (this.lastFinalCaption) {
              const lastFinalLower = this.lastFinalCaption.toLowerCase();
              const newCaptionLower = captionText.toLowerCase();

              // Simple substring check first - if new caption starts with a significant portion of the last final
              const last50Chars = lastFinalLower.slice(-50).trim();
              if (last50Chars.length > 20 && newCaptionLower.startsWith(last50Chars.slice(0, 30))) {
                console.log('Skipping duplicate - starts with end of last final caption');
                return;
              }

              // Get words from both (only words longer than 3 chars for better matching)
              const lastFinalWords = lastFinalLower.split(/\s+/).filter(w => w.length > 3);
              const newCaptionWords = newCaptionLower.split(/\s+/).filter(w => w.length > 3);

              // Only check if we have enough words
              if (lastFinalWords.length >= 10 && newCaptionWords.length >= 10) {
                // Check if the first 10 words of new caption match any 10 consecutive words in last final
                const firstNewWords = newCaptionWords.slice(0, 10);

                // Look for this sequence in the last finalized caption
                for (let i = 0; i <= lastFinalWords.length - 10; i++) {
                  const sequence = lastFinalWords.slice(i, i + 10);

                  // Count exact sequential matches
                  let matches = 0;
                  for (let j = 0; j < 10; j++) {
                    if (firstNewWords[j] === sequence[j]) {
                      matches++;
                    } else {
                      // Break on first mismatch for sequential checking
                      break;
                    }
                  }

                  // If 7+ consecutive words match, it's a duplicate
                  if (matches >= 7) {
                    console.log(`Skipping duplicate - ${matches} consecutive word match with last finalized caption`);
                    return;
                  }
                }
              }
            }

            // Accept this caption as it's longer and not a duplicate
            this.currentInterimCaption = captionText;
            this.lastInterimLength = captionText.length;

            // Clear any existing timer
            if (this.interimUpdateTimer) {
              clearTimeout(this.interimUpdateTimer);
            }

            // Increased debounce to 300ms to reduce flickering from minor corrections
            this.interimUpdateTimer = setTimeout(() => {
              // Combine all finalized text + current interim caption
              let fullText = this.allFinalizedText;
              if (this.currentInterimCaption) {
                fullText += (this.allFinalizedText ? '<br><br>' : '') + this.currentInterimCaption;
              }
              this.strCaptionsDisplay = [fullText];

              this.scrollToBottom(true);
              this.ref.detectChanges();
              this.interimUpdateTimer = null;
            }, 300);


          }, this)


        });

      }).then(() => this.openTokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }

  public increaseFont() {
    this.fontSize += 5;
  }

  public decreaseFont() {
    this.fontSize -= 5;
  }


}
